export default __webpack_public_path__ + "static/media/notion.ecaa92d5.gif";